import React from "react";
import LandingMob from "../../assets/svg/landing-mob.svg";
import "./style.scss";
interface LayoutProps {
  children: React.ReactNode;
}
const MainLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="bg-white w-[100%] h-[100%] sm:p-0 p-[18px]">
      <div className="block sm:flex sm:h-[100vh]">
        <div className="sm:w-1/2">
          <div className="landing-pattern"></div>
          <div className="sm:hidden block">
            <img src={LandingMob} alt="LandingMob" className="w-[100%]" />
          </div>
        </div>
        {/* Main Content */}
        <div className="sm:w-1/2 h-[100%]">
          <main className="flex-grow w-[100%]">{children}</main>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
